import React from "react";

import Typography from "@mui/material/Typography";

import { omit } from "@app/common/utils";

import IconBackground from "@rui/IconBackground";
import { Row, StackProps } from "@rui/Stack";

import { IconCategory, ICON_BY_CATEGORY } from "./Icons";

interface CustomIconHeadingProps {
  color?: React.CSSProperties["backgroundColor"];
  startIcon: React.ReactNode;
}

interface DefaultIconHeadingProps {
  type: IconCategory;
}

type IconHeadingIconProps = (
  | CustomIconHeadingProps
  | DefaultIconHeadingProps
) & {
  shape?: "round" | "square";
  size?: "small" | "default";
};
type IconHeadingProps = StackProps & IconHeadingIconProps;

export const IconHeadingIcon = (props: IconHeadingIconProps) => {
  const height = props.size === "small" ? 20 : 24;
  const sx = {
    borderRadius: (props.shape ?? "round") === "square" ? "4px" : "50%",
  };

  if ("type" in props) {
    const { Icon, color, bgcolor } = ICON_BY_CATEGORY[props.type];
    return (
      <IconBackground
        className="icon-heading__icon"
        height={height}
        sx={{ ...sx, bgcolor }}
      >
        <Icon sx={{ color }} />
      </IconBackground>
    );
  }

  return (
    <IconBackground
      className="icon-heading__icon"
      height={height}
      sx={{ ...sx, bgcolor: props.color }}
    >
      {props.startIcon}
    </IconBackground>
  );
};

const IconHeading = (props: IconHeadingProps) => {
  const rowProps = omit(["type", "startIcon", "color", "shape", "size"], props);

  return (
    <Row variant="left" spacing={1} {...rowProps}>
      <IconHeadingIcon {...props} />
      <Typography
        variant={props.size === "small" ? "bodyPrimaryMed" : "h3"}
        color="shades.neutral.700"
      >
        {props.children}
      </Typography>
    </Row>
  );
};

export default IconHeading;
